const stringForAutocomplete = (hit) => {
  const regex = /<ais-highlight-0000000000>(\w+)<\/ais-highlight-0000000000>(\w*)/;
  const fieldsForAutocomplete = ['title', 'teaser', 'content', 'context_info', 'summary'];

  let autocompleteText = '';

  for (const field of fieldsForAutocomplete) {
    if (hit._highlightResult[field].value) {
      const match = hit._highlightResult[field].value.match(regex);

      if (match) {
        const matchedString = match[1];
        const followingCharacters = match[2];

        autocompleteText = matchedString + followingCharacters;

        break; // Exit the loop as soon as a match is found
      }
    }
  }

  return autocompleteText;
}

const htmlForResult = (hit) => {
  if (hit.teaserHtml && hit.teaserHtml.includes('<b>')) {
    return hit.teaserHtml;
  }

  if (hit.contentHtml && hit.contentHtml.includes('<b>')) {
    return hit.contentHtml;
  }

  if (hit.contextInfoHtml && hit.contextInfoHtml.includes('<b>')) {
    return hit.contextInfoHtml;
  }

  if (hit.summaryHtml && hit.summaryHtml.includes('<b>')) {
    return hit.summaryHtml;
  }

  // display teaser as fallback
  return hit.teaserHtml;
}

export {
  stringForAutocomplete,
  htmlForResult
}



// WEBPACK FOOTER //
// ./search/searchHelper.js